const menuItems = {
  items: [
    {
      id: 'user',
      title: 'User',
      type: 'group',    
      backIcon :'fa fa-chevron-left',  
      backUrl : '/',
      children: [
        {
          id: 'user-task',
          title: 'Task Board',
          type: 'item',
          url: '/users/task-board',
          icon: 'fa fa-tasks',          
        },
        {
          id: 'user-todo',
          title: 'Todo',
          type: 'item',
          url: '/users/todo',
          icon: 'fa fa-tasks',          
        },
        {
          id: 'user-calendar',
          title: 'Calendar',
          type: 'item',
          url: '/users/full-calendar',
          classes: 'nav-item',
          icon: 'feather icon-calendar',
        },
        {
          id: 'user-notification',
          title: 'Notification',
          type: 'item',
          url: '/users/notification',
          classes: 'nav-item',
          icon: 'feather icon-bell',
        },                  
        {
          id: 'user-profile',
          title: 'Profile',
          type: 'item',
          url: '/users/user-profile',
          icon: 'feather icon-users',          
        },        
        {
          id: 'theme',
          title: 'Theme',
          type: 'item',
          url: '/users/user-list',
          icon: 'fa fa-paint-roller',
        },             
      ],
    },    
  ],
}

export default menuItems
